import type { AddressErrors, AddressInput } from '../lib/address';
import { normalizePostcode } from '../lib/address';
import { Field } from './ui';

/**
 * Gewone adresvelden (straat, huisnummer, toevoeging, postcode, plaats). De postcode wordt bij het verlaten van het
 * veld netjes gezet ("1234ab" → "1234 AB"); de database controleert en normaliseert ook (save_location).
 */
export function AddressFields({
  value,
  onChange,
  errors = {},
  required = false,
  disabled = false,
}: {
  value: AddressInput;
  onChange: (next: AddressInput) => void;
  errors?: AddressErrors;
  required?: boolean;
  disabled?: boolean;
}) {
  const set = (k: keyof AddressInput) => (e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...value, [k]: e.target.value });
  const opt = required ? '' : ' (optioneel)';
  return (
    <div className="address-grid">
      <div className="address-row">
        <div>
          <Field label={`Straat${opt}`} error={errors.street}>
            {(p) => <input {...p} className="input" value={value.street} onChange={set('street')} disabled={disabled} autoComplete="address-line1" />}
          </Field>
        </div>
        <div>
          <Field label="Huisnummer" error={errors.house_number}>
            {(p) => (
              <input {...p} className="input" value={value.house_number} onChange={set('house_number')} disabled={disabled} inputMode="numeric" />
            )}
          </Field>
        </div>
        <div>
          <Field label="Toevoeging" error={errors.house_number_addition}>
            {(p) => (
              <input {...p} className="input" value={value.house_number_addition} onChange={set('house_number_addition')} disabled={disabled} />
            )}
          </Field>
        </div>
      </div>
      <div className="address-row second">
        <div>
          <Field label="Postcode" error={errors.postal_code}>
            {(p) => (
              <input
                {...p}
                className="input"
                value={value.postal_code}
                onChange={set('postal_code')}
                onBlur={() => {
                  const n = normalizePostcode(value.postal_code);
                  if (n && n !== value.postal_code) onChange({ ...value, postal_code: n });
                }}
                disabled={disabled}
                autoComplete="postal-code"
                placeholder="1234 AB"
              />
            )}
          </Field>
        </div>
        <div>
          <Field label="Plaats" error={errors.city}>
            {(p) => <input {...p} className="input" value={value.city} onChange={set('city')} disabled={disabled} autoComplete="address-level2" />}
          </Field>
        </div>
      </div>
    </div>
  );
}
